import { FundingSourceAccessResponse } from "admin/types/interfaces/funding";
import { useFetcher } from "~/hooks/useFetcher";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useFundingSourceAccess = (fundingSourceId: number | null) => {
  const url =
    fundingSourceId != null
      ? `${ACCESS_CONTROLLER_V1}/funding-sources/${fundingSourceId}/access`
      : null;
  return useFetcher<FundingSourceAccessResponse>(url, {
    shouldCamelize: true,
  });
};

export default useFundingSourceAccess;
